export default __webpack_public_path__ + "static/media/web-locator.d774c1c9.svg";